/*
 * @Author: guozhenqiang 15138913894@163.com
 * @Date: 2023-02-27 10:53:24
 * @LastEditors: guozhenqiang 15138913894@163.com
 * @LastEditTime: 2023-03-03 16:49:34
 * @FilePath: \baichuan-website\src\request\http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import axios from "axios";
import ElementUI from "element-ui";
import Router from "vue-router";
axios.defaults.baseURL = "/api";
//http://39.105.100.231:8430
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8;multipart/form-data";
axios.defaults.headers["Cache-Control"] = "no-cache";
axios.defaults.withCredentials = true;
axios.interceptors.request.use(function (config) {
  if (sessionStorage.getItem("token")) {
    config.headers.token = sessionStorage.getItem("token");
  }
  return config;
});
// http响应拦截器
axios.interceptors.response.use(
  res => {
    var code = res.httpStatus;
    return res;
  },
  error => {
    return Promise.reject(error);
  }
);
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
//兼容接口上缀参数
export function get2(url, id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${url}/${id}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
/**
 * PUT方法，对应PUT请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * delete方法，对应PUT请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deletes(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}



// WEBPACK FOOTER //
// ./src/request/http.js